import { render, staticRenderFns } from "./contentArea.vue?vue&type=template&id=c4f220c6&scoped=true&"
import script from "./contentArea.vue?vue&type=script&lang=js&"
export * from "./contentArea.vue?vue&type=script&lang=js&"
import style0 from "./contentArea.vue?vue&type=style&index=0&id=c4f220c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f220c6",
  null
  
)

export default component.exports